import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=1aece104"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports